
/**************************************************
*  SLIDER
**************************************************/
$(function () {
  //- where
  // const detectSliderSection = () => {
  //   const sections = ['trustpilot', 'partners-slider', 'values'];

  //   return !!sections.filter(v => $('section#' + v).length !== 0).length;
  // };

  if ($('section.slider').length !== 0) {

    function initSlider(){
      let slides = [];
      clearSlider();
      $('.slide:first-of-type').removeClass('hide').addClass('active');
      //- populate slides array with post IDs
      $('.slide').each(function () {
        const id = $(this).attr("data-slide-id");
        slides.push(id);
        //- init slider's dots
        if ($(this).hasClass('active')) {
          $("#carousel-item-" + id).prop("checked", true);
        }
      });
      return slides;
    }

    function clearSlider(){
      $(".slide").each(function() {
        const id = $(this).attr("data-slide-id");
        $("#carousel-item-" + id).prop("checked", false);
        $(this).addClass('hide').removeClass('active');
      });
    }
    //- update prev / next nav
    function updateSlider(commentID) {
      $("#slide-" + commentID).removeClass('hide').addClass('active');
      $("#carousel-item-" + commentID).prop("checked", true);
    }

    let slides = initSlider();
    let currentCommentID = $(".slide.active").attr("data-slide-id").toString();
    let prevCommentID = 0;
    let nextCommentID = 0;

    $(".next").on('click', function (e) {
      e.preventDefault();
      const nextIndex = slides.indexOf(currentCommentID) + 1;
      nextCommentID = nextIndex < slides.length ? slides[nextIndex] : slides[0];
      clearSlider();
      updateSlider(nextCommentID);
      currentCommentID = nextCommentID;
    });

    $(".prev").on('click', function (e) {
      e.preventDefault();
      const prevIndex = slides.indexOf(currentCommentID) - 1;
      prevCommentID = prevIndex >= 0 ? slides[prevIndex] : slides[slides.length-1];
      clearSlider();
      updateSlider(prevCommentID);
      currentCommentID = prevCommentID;
    });

    //- dots nav
    $("label").on('click', function (e) {
      clearSlider();
      $(this).prop("checked", true);
      const id = $(this).attr("data-slide-id");
      updateSlider(id);
      currentCommentID = id;
    });
  }
});
